import * as React from 'react';
import { Col, Row } from 'antd';
import { Prompt } from 'react-router';

import { CardController } from 'src/app/shared/card.controller';
import { HeaderView } from 'src/app/shared/header.view';
import { Column, DataTableView } from 'src/core/ui/data-table.view';
import { DropdownView } from 'src/core/ui/dropdown.view';
import { TabLanguageInlineView } from 'src/core/ui/language/tab-language-inline.view';

interface IDocumentTemplateCategoryListViewProps extends ComponentViewProps<DataSet<DocumentTemplateCategoryItem>> {
	defaultLanguage: string;
	mode: ControlMode;
	onModeChange: (mode: ControlMode) => void;
	isValidItem: (item: DocumentTemplateCategoryItem) => boolean;
	createNewItem: () => Promise<DocumentTemplateCategoryItem>;
	save: () => Promise<void>;
	cancel: () => Promise<void>;
}

export class DocumentTemplateCategoryListView extends React.Component<IDocumentTemplateCategoryListViewProps, any> {
	categoryUsages = [
		{ value: 1, label: 'Agents' },
		{ value: 2, label: 'Clients' },
		{ value: 4, label: 'Quotes' },
		{ value: 8, label: 'Suppliers' }
	];

	categoryTypes = [
		{ value: 0, label: 'General' },
		{ value: 1, label: 'Invoice' },
		{ value: 2, label: 'Offer' },
		{ value: 3, label: 'Voucher' },
		{ value: 4, label: 'Report' },
	];

	columns: Column[] = [
		{
			title: 'Name',
			key: 'dynamicProperties.displayName',
			dataIndex: 'dynamicProperties.displayName',
			width: '50%',
			editable: (value: { [lang: string]: string }, record: DocumentTemplateCategoryItem, index: number, isSelected: boolean) => {
				if (isSelected) {
					const translations = [
						{
							title: 'Title',
							dynamicProperties: record.dynamicProperties.displayName,
							required: true
						}];

					return (
						<TabLanguageInlineView
							dynamicProperties={translations}
							mode={this.props.mode}
							setBusy={this.props.setBusy}
							model={record}
						/>
					);
				} else if (value == null) {
					return null;
				}

				return value[this.props.defaultLanguage] || "";
			}
		},
		{
			title: 'Usages',
			key: 'usages',
			dataIndex: 'usages',
			width: '30%',
			editable: (value: DocumentTemplateUsages[], record: DocumentTemplateCategoryItem, index: number, isSelected: boolean) => {
				if (isSelected) {
					return (
						<DropdownView
							model={record.usages}
							options={this.categoryUsages}
							label={null}
							disabled={this.props.mode === 'display'}
							multi={true}
							onChanged={(newValue) => {
								record.usages = Array.isArray(newValue) ? newValue.map(m => m.value) : [newValue.value];
							}}
						/>
					);
				} else if (value == null) {
					return null;
				}

				const labels = value
					.map(m => this.categoryUsages.find(p => p.value == m).label)
					.join(', ');
				return labels;
			}
		},
		{
			title: 'Type',
			key: 'type',
			dataIndex: 'type',
			width: '20%',
			editable: (value: number, record: DocumentTemplateCategoryItem, index: number, isSelected: boolean) => {
				if (isSelected) {
					return (
						<DropdownView
							model={record.type}
							options={this.categoryTypes}
							label={null}
							required={true}
							disabled={this.props.mode === 'display'}
							onChanged={(newValue) => record.type = newValue.value}
						/>
					);
				} else if (value == null) {
					return null;
				}

				return this.categoryTypes.find((m) => m.value === value).label || "";
			}
		},

	];

	constructor(props: IDocumentTemplateCategoryListViewProps) {
		super(props);
	}

	render() {
		if (this.props.model == null || this.props.model.items == null) {
			return null;
		}

		return (
			<div className="window window-normal">
				<Prompt
					when={this.props.model.isDirty}
					message={location => `If you go to ${location.pathname}, all changes will be lost. Are you sure you want to continue?`}
				/>
				<Row>
					<Col xs={24}>
						<HeaderView title="Document Template Categories"
							mode={this.props.mode}
							onModeChanged={this.props.onModeChange}
							save={this.props.save}
							cancel={this.props.cancel}
							contextService={this.props.model}
						/>
					</ Col>
					<Col xs={24}>
						<CardController
							className="card-borderless"
							mode={this.props.mode}>
							<DataTableView
								model={this.props.model}
								columns={this.columns}
								setBusy={this.props.setBusy}
								mode={this.props.mode}
								createNewItem={this.props.createNewItem}
							/>
						</CardController>
					</Col>
				</Row>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/document-template-categories/list/document-template-category-list.view.tsx